module.exports = __webpack_public_path__ + "assets/img/pinpai-cp2.bed5cb66.png";